<template>
  <el-col>
    <el-card class="data">
      <div class="flex-space-between w100" slot="header">
        <div class="flex-center">
          <img class="report-img" src="@/assets/images/channels.svg" alt="" />
          <span>OVERVIEW</span>
        </div>
        <div class="videos-buttons">
          <Filters />
          <el-tooltip content="Report" placement="top">
            <el-button
                type="success"
                circle
                icon="el-icon-document"
                @click="generateReport()"
                class="ml10"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <div class="d-grid">
        <div
          class="tableCommands"
          :class="window.width < '710' ? 'flex-end' : 'd-none'"
        >
          <p
            class="ml10"
            v-for="(item, index) in columns"
            :key="index"
            @click="handleCommand(item)"
            :class="{ active: columnShown === item.name }"
          >
            {{ item.name }}
          </p>
        </div>
        <el-table
          :data="channels.data"
          :default-sort="{ prop: order_column, order: order_type }"
          @sort-change="sort"
          class="w100"
          stripe
          v-loading="loading"
        >
          <el-table-column label="Name" prop="name" sortable>
            <template slot-scope="props">
              <a
                :href="`https://youtube.com/channel/${props.row.channel_id}`"
                target="_blank"
              >
                {{ props.row.name }}
              </a>
            </template>
          </el-table-column>
          <el-table-column
            label="Country"
            prop="country"
            align="right"
            v-if="columnShown === 'Country' || window.width > '710'"
            sortable
          ></el-table-column>
          <el-table-column
            label="Subscribers"
            prop="subscribers"
            align="right"
            v-if="columnShown === 'Subscribers' || window.width > '710'"
            sortable
            :formatter="commaNumTable"
          ></el-table-column>
          <el-table-column
            label="Views"
            prop="views"
            align="right"
            v-if="columnShown === 'Views' || window.width > '710'"
            sortable
            :formatter="commaNumTable"
          ></el-table-column>
          <el-table-column
            label="No. Videos"
            prop="video"
            align="right"
            sortable
            v-if="columnShown === 'Videos' || window.width > '710'"
          ></el-table-column>
          <el-table-column
            label="Category"
            prop="category"
            align="right"
            v-if="columnShown === 'Category' || window.width > '710'"
            sortable
          ></el-table-column>
        </el-table>
        <el-pagination
          class="float-right"
          background
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="channels.current_page"
          :page-sizes="[5, 10, 25, 50, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="channels.total"
        ></el-pagination>
        <el-dialog
          :title="channel_chart_name"
          :visible.sync="dialog_visible"
          width="75%"
          top="7vh"
          @close="closeChartDialog()"
        >
          <div class="flex-end">
            <el-date-picker
              v-model="current_date_range"
              type="daterange"
              unlink-panels
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              :picker-options="dateRangeOptions"
              format="d MMMM yyyy"
              value-format="yyyy-MM-dd"
              @change="setRange()"
            ></el-date-picker>
          </div>
          <el-tabs :tab-position="subTabsPosition" v-model="activeName">
            <el-col :span="12">
              <el-divider content-position="left">Views</el-divider>
            </el-col>
            <el-col :span="12">
              <el-divider content-position="left">Subscribers</el-divider>
            </el-col>
            <el-col id="vid" :span="12" :lg="12">
              <GChart
                type="LineChart"
                :data="channel_chart_views"
                :options="LineChartSett"
                v-if="channel_chart_views.length > 1"
              />
              <div v-else class="no-data"><span>No Data</span></div>
            </el-col>
            <el-col id="vid" :span="12" :lg="12">
              <GChart
                type="LineChart"
                :data="channel_chart_subscribers"
                :options="LineChartSett"
                v-if="channel_chart_subscribers.length > 1"
              />
              <div v-else class="no-data"><span>No Data</span></div>
            </el-col>
          </el-tabs>
        </el-dialog>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import Filters from './Filters'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  components: {
    GChart,
    Filters
  },

  data() {
    return {
      channel_chart_name: '',
      subTabsPosition: 'top',
      activeName: 'first',
      dialog_visible: false,
      current_date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ],
      current_channel: null,
      columnShown: 'Country',
      columns: [
        {
          name: 'Country',
          command: 'country'
        },
        {
          name: 'Subscribers',
          command: 'subscribers'
        },
        {
          name: 'Views',
          command: 'views'
        },
        {
          name: 'Videos',
          command: 'videos'
        },
        {
          name: 'Category',
          command: 'category'
        }
      ]
    }
  },

  computed: {
    ...mapState('artistChannels', [
      'loading',
      'date_range',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'channels',
      'channel_chart',
      'LineChartSett'
    ]),

    ...mapGetters('auth', ['admin_role']),
    ...mapGetters('artistChannels', [
      'channel_chart_views',
      'channel_chart_subscribers'
    ])
  },

  methods: {
    ...mapActions('artistChannels', ['readChannelChart', 'readMyChannels']),
    ...mapMutations('artistChannels', [
      'setDateRange',
      'setPage',
      'setPageSize',
      'setOrdering',
      'setChannelChart',
      'setCsv'
    ]),

    handleCommand(column) {
      this.columnShown = column.name
      this.readTopChannel(column.command)
    },

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readMyChannels()
    },
    currentChange(page) {
      this.setPage(page)
      this.readMyChannels()
    },
    readChannelChartData(data) {
      this.dialog_visible = true
      this.channel_chart_name = data.name
      this.current_channel = data.channel_id
      this.readChannelChart({
        id: data.channel_id,
        start: this.date_range[0],
        end: this.date_range[1]
      })
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readMyChannels()
    },
    setRange() {
      this.setDateRange(this.current_date_range)
      this.readChannelChart({
        id: this.current_channel,
        start: this.date_range[0],
        end: this.date_range[1]
      })
    },
    closeChartDialog() {
      this.current_channel = null
      this.dialog_visible = false
      this.current_date_range = [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ]
      this.setDateRange(this.current_date_range)
      this.setChannelChart([])
    },

    generateReport(){
      this.setCsv(1)
      this.readMyChannels()
    }
  },
  created() {
    this.readMyChannels()
    window.addEventListener('resize', this.windowWidth)
    this.windowWidth()
  },

  destroyed() {
    window.removeEventListener('resize', this.windowWidth)
    this.setPage(1)
  }
}
</script>

<style scoped>
h1 {
  text-align: left;
  margin: 4rem 3rem 4rem;
  font-weight: 200;
  font-size: 1.7rem;
}

h2 {
  color: #3e3e3e;
  font-size: 1.6rem;
  text-align: left;
  font-weight: 100;
  margin: 1.2rem 0.5rem 2rem;
}
.videos-buttons{
  display: flex;
}
</style>
